// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"aa70727a","286":"8fd6e373"}[chunkId] + ".chunk.js";
};